import type { FaireProductEntity } from "../../entity_types/product";

export const p_ef55jp2vzd: FaireProductEntity = {
  token: "p_ef55jp2vzd",
  type: "product",
  name: "Elysian 18K Gold Boho Baroque Heart Color Bracelet",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/971f037540640c2aad1778e2bf55a3f1c0d6cc02e3fa2f2c09ac9a23fddd0025.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/101f51afbed26cc34a06fdb3a6187b9170c9ed8fa45b800660334cf04023de6c.jpeg",
    "https://cdn.faire.com/fastly/144022adc91ad5c547488e066830fdeca9e2d2afefc2b333e52a3f2e4c30e0b6.jpeg",
  ],
  priceDollars: 12.54,
  description:
    "Matte 18K Gold-Plated Baroque Heart Multi-Color Bracelet \n\n1. Matte 18K Gold Plating \n2. Cubic Zirconia \n3. Alloy\nBrass\nPendant Size-Hearts (inch): 0.7\nChain Length (inch): 7\nExtension Length (inch): 0\n\nElevate your wrist with our Matte 18K Gold-Plated Baroque Heart Multi-Color Bracelet. This preppy and vintage-inspired piece is a colorful and bold accessory that truly makes a statement, adding a touch of uniqueness to your style.\n \n- Nickel-free, Lead-safe",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:11.727Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
